export default __webpack_public_path__ + "static/media/hero-img.fe6507cc.jpg";